import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-width": "1.125",
  d: "M15.353 8.532a.937.937 0 0 1 0 .937l-2.396 4.15a.938.938 0 0 1-.812.469H7.354a.938.938 0 0 1-.812-.47L4.146 9.47a.937.937 0 0 1 0-.937l-.487-.282.487.282 2.396-4.15a.937.937 0 0 1 .812-.469h4.792c.334 0 .644.179.811.469l2.396 4.15Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "9.75",
  cy: "9",
  r: "1.685",
  stroke: "currentColor",
  "stroke-width": "1.125"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }